import { render } from "./GridItemSkeleton.vue?vue&type=template&id=35cb31f2"
import script from "./GridItemSkeleton.vue?vue&type=script&lang=js"
export * from "./GridItemSkeleton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__